// Export watermark for the free tier (AC-G1: "Free-Export trägt Wasserzeichen;
// Starter+ nicht"). Pure 2D-canvas drawing so the monolith's export path can
// stamp the bitmap right before encoding. Decoupled from gating via
// watermarkIfNeeded(); unit-tested against a mock context (no real canvas).

import type { Tier } from '../domain/types';
import { shouldWatermark } from '../domain/gating';
import { stampCornerText, type StampCtx } from './canvas-stamp';

/** @deprecated alias — use StampCtx. Kept for existing imports. */
export type WatermarkCtx = StampCtx;

export interface WatermarkOptions {
  text?: string;
  /** Fraction of the shorter side used as font size. Default 0.04 (4%). */
  fontScale?: number;
  /** Opacity 0..1. Default 0.55. */
  opacity?: number;
  /** Padding in px from the bottom-right corner. Default 16. */
  padding?: number;
}

const DEFAULTS = {
  text: 'JOE FLOW',
  fontScale: 0.04,
  opacity: 0.55,
  padding: 16,
} as const;

/**
 * Stamp a bottom-right brand watermark onto the context. Saves/restores so the
 * caller's drawing state is untouched. Returns the pixel font size used.
 */
export function drawWatermark(
  ctx: WatermarkCtx,
  width: number,
  height: number,
  opts: WatermarkOptions = {},
): number {
  return stampCornerText(ctx, width, height, {
    text: opts.text ?? DEFAULTS.text,
    corner: 'br',
    fontScale: opts.fontScale ?? DEFAULTS.fontScale,
    opacity: opts.opacity ?? DEFAULTS.opacity,
    padding: opts.padding ?? DEFAULTS.padding,
    minFont: 12,
    maxFont: 64,
  });
}

/** Apply the watermark only when the tier requires it (free). Returns applied?. */
export function watermarkIfNeeded(
  ctx: WatermarkCtx,
  width: number,
  height: number,
  tier: Tier,
  opts?: WatermarkOptions,
): boolean {
  if (!shouldWatermark(tier)) return false;
  drawWatermark(ctx, width, height, opts);
  return true;
}
